import { EnvironmentInjector, inject, Injectable, runInInjectionContext } from '@angular/core';
import { FirestoreHistory, History } from '@jessie/commons';
import { Observable } from 'rxjs';
import { ORGA_FIRESTORE_SERVICE } from './firestore.service';
import { limit, where } from '@angular/fire/firestore';
import { SessionStateService } from './session-state.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private injector = inject(EnvironmentInjector);
  private orgaFirestoreService = inject(ORGA_FIRESTORE_SERVICE);
  private sessionState = inject(SessionStateService);

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getHistory(id: string): Observable<FirestoreHistory[]> {
    return this.sessionState
      .getOrgaId()
      .pipe(
        switchMap((orgaUserId) =>
          this.orgaFirestoreService.getDocsByCollectionGroup<History>(
            'history',
            this.inCtx(() => where('orgaId', '==', orgaUserId)),
            this.inCtx(() => where('id', '==', id)),
            this.inCtx(() => where('lastEditor', '!=', false)),
            this.inCtx(() => limit(100))
          )
        )
      );
  }
}
